<template>
    <div class="supplier-management">
        <!-- 搜索和操作区 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="供应商名称">
                    <el-input v-model="searchForm.supplierName" placeholder="请输入供应商名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchSuppliers" icon="el-icon-search">搜索</el-button>
                    <el-button @click="getList()" icon="el-icon-refresh">重置</el-button>
                    <el-button type="success" @click="showAddDialog" icon="el-icon-plus">新增供应商</el-button>
                </el-form-item>
            </el-form>
        </el-card>



        <!-- 供应商列表 -->
        <el-card class="main-content">
            <el-table ref="supplierTable" :data="filteredSuppliers" border stripe
                :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }" @row-click="handleRowClick"
                height="60vh">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index" width="55" align="center"></el-table-column>
                <el-table-column prop="supplierName" label="供应商名称" align="center"></el-table-column>
                <el-table-column prop="contactInfo" label="联系电话" align="center"></el-table-column>
                <el-table-column prop="address" label="供应商地址" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" align="center" width="105">
                    <template #default="scope">
                        <el-tag :type="statusTypeMap[scope.row.status]">
                            {{ formatStatus(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="400">
                    <template #default="scope">
                        <el-button type="text" size="small"
                            @click="handleShowQualificationDialog(scope.row.supplierId)">
                            新增资质图片
                        </el-button>
                        <el-button type="text" size="small"
                            @click="handleShowQualificationDialog1(scope.row.supplierId)">
                            查看资质图片
                        </el-button>
                        <el-button type="text" size="small" @click="handleShowAddDish(scope.row.supplierId)">
                            新增物料
                        </el-button>
                        <el-button type="text" size="small" @click="handleShowAddDish1(scope.row.supplierId)">
                            查看物料
                        </el-button>
                        <el-button type="text" size="small" @click="showEditDialog(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" class="text-danger"
                            @click="delSupplier(scope.row.supplierId)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
                    :total="filteredSuppliers.length" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </el-card>

        <!-- 1. 新增/编辑供应商弹窗 -->
        <el-dialog :title="isEditMode ? '编辑供应商' : '新增供应商'" :visible.sync="formVisible" width="800px"
            :close-on-click-modal="false" :z-index="3000" append-to-body>
            <div class="step-content">
                <el-form :model="supplierForm" :rules="basicRules" ref="basicForm" label-width="120px"
                    class="form-container">
                    <el-form-item label="供应商名称" prop="supplierName">
                        <el-input v-model="supplierForm.supplierName" placeholder="请输入供应商名称"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="contactInfo">
                        <el-input v-model="supplierForm.contactInfo" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="联系地址" prop="address">
                        <el-input v-model="supplierForm.address" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    <el-form-item label="合作状态" prop="status">
                        <el-select v-model="supplierForm.status" placeholder="请选择合作状态">
                            <el-option label="合作中" value="0"></el-option>
                            <el-option label="已终止" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取消</el-button>
                <el-button type="success" @click="saveSupplier">保存</el-button>
            </div>
        </el-dialog>

        <!-- 2. 图片预览弹窗 -->
        <el-dialog :title="previewImageTitle" :visible.sync="previewImageVisible" width="80%"
            :close-on-click-modal="true">
            <div class="image-preview-container">
                <img :src="previewImageUrl" class="preview-image" :alt="previewImageTitle">
            </div>
        </el-dialog>

        <!-- 3. 新增供应商物料弹窗 -->
        <el-dialog title="新增供应商物料" :visible.sync="addDishVisible" width="800px" :close-on-click-modal="false"
            append-to-body :z-index="3000">
            <el-table :data="supplierForm.dishes" border class="dish-table" style="margin-top: 10px;">
                <el-table-column label="物料图片" width="120">
                    <template #default="scope">
                        <el-upload action="#" :show-file-list="false"
                            :on-change="(file) => handleDishImagePreview(file, scope.$index)"
                            :before-upload="beforeImageUpload" class="dish-avatar-uploader" :auto-upload="false">
                            <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl" class="dish-image-preview"
                                alt="物料图片">
                            <i v-else class="el-icon-plus dish-upload-icon"></i>
                        </el-upload>
                    </template>
                </el-table-column>
                <el-table-column label="物料名称" prop="bomName" width="150">
                    <template #default="scope">
                        <el-input v-model="scope.row.bomName" size="mini" placeholder="请输入物料名称"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="单位" prop="unit" width="150">
                    <template #default="scope">
                        <el-input v-model="scope.row.unit" size="mini" placeholder="请输入单位"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="单价(元)" prop="price" width="120">
                    <template #default="scope">
                        <el-input v-model.number="scope.row.price" size="mini" placeholder="0.00"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template #default="scope">
                        <el-button type="text" size="small" class="text-danger" @click="removeDishItem(scope.$index)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="primary" size="mini" @click="addDishItem" style="margin-top: 10px;">
                <i class="el-icon-plus"></i> 添加物料
            </el-button>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDishVisible = false">取消</el-button>
                <el-button type="primary" @click="submitDishForm">保存物料</el-button>
            </div>
        </el-dialog>

        <!-- 4. 新增资质图片弹窗 -->
        <el-dialog title="新增供应商资质图片" :visible.sync="addQualificationVisible" width="600px" :close-on-click-modal="false"
            append-to-body :z-index="3000">
            <el-form :model="qualificationForm" :rules="qualificationRules" ref="qualificationFormRef"
                label-width="120px" class="form-container">
                <el-form-item prop="supplierId" hidden>
                    <el-input v-model="qualificationForm.supplierId"></el-input>
                </el-form-item>
                <el-form-item label="营业执照" prop="file1">
                    <el-upload ref="uploadFile1" action="#" :show-file-list="false"
                        :on-change="(file, fileList) => handleQualificationPreview(file, 'file1')"
                        :before-upload="beforeImageUpload" class="avatar-uploader" :auto-upload="false">
                        <img v-if="qualificationForm.file1" :src="qualificationForm.file1" class="license-image"
                            alt="营业执照">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持JPG、PNG格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="食品经营许可证" prop="file2">
                    <el-upload ref="uploadFile2" action="#" :show-file-list="false"
                        :on-change="(file, fileList) => handleQualificationPreview(file, 'file2')"
                        :before-upload="beforeImageUpload" class="avatar-uploader" :auto-upload="false">
                        <img v-if="qualificationForm.file2" :src="qualificationForm.file2" class="license-image"
                            alt="食品经营许可证">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持JPG、PNG格式，大小不超过2MB</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addQualificationVisible = false">取消</el-button>
                <el-button type="primary" @click="submitQualificationForm">保存资质</el-button>
            </div>
        </el-dialog>

        <!-- 5. 查看资质图片弹窗（支持点击更换） -->
        <el-dialog title="查看供应商资质图片" :visible.sync="viewQualificationVisible" width="800px"
            :close-on-click-modal="false" append-to-body :z-index="3000">
            <div class="view-qualification-container">
                <!-- 营业执照 -->
                <div class="qualification-item">
                    <h4 class="item-title">营业执照</h4>
                    <div class="image-container" @click="handleReplaceQualification('file1')"
                        :class="{ 'no-image': !viewQualificationData.file1 }">
                        <img v-if="viewQualificationData.file1" :src="viewQualificationData.file1"
                            class="qualification-image" alt="营业执照">
                        <div v-else class="image-placeholder">
                            <i class="el-icon-picture-outline"></i>
                            <p>未上传营业执照</p>
                        </div>
                        <div v-if="viewQualificationData.file1" class="replace-tip">点击更换图片</div>
                    </div>
                </div>
                <!-- 食品经营许可证 -->
                <div class="qualification-item">
                    <h4 class="item-title">食品经营许可证</h4>
                    <div class="image-container" @click="handleReplaceQualification('file2')"
                        :class="{ 'no-image': !viewQualificationData.file2 }">
                        <img v-if="viewQualificationData.file2" :src="viewQualificationData.file2"
                            class="qualification-image" alt="食品经营许可证">
                        <div v-else class="image-placeholder">
                            <i class="el-icon-picture-outline"></i>
                            <p>未上传食品经营许可证</p>
                        </div>
                        <div v-if="viewQualificationData.file2" class="replace-tip">点击更换图片</div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Close">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 6. 物料管理抽屉 -->
        <el-drawer title="物料管理" :visible.sync="detailDrawerVisible" placement="right" size="60%"
            :close-on-click-modal="false" :append-to-body="true" custom-class="detail-drawer">
            <el-table ref="supplierTable" :data="Listdish" border stripe
                :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }" @row-click="handleRowClick"
                height="50vh">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="photo" label="物料图片" width="120">
                    <template #default="scope">
                        <div class="dish-photo-container">
                            <img v-if="scope.row.photo" :src="scope.row.photo" class="dish-photo" alt="物料图片"
                                @click="previewDishPhoto(scope.row.photo)">
                            <div v-else class="dish-photo-placeholder">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="bomName" label="物料名称"></el-table-column>
                <el-table-column prop="price" label="物料单价" align="center"></el-table-column>
                <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                <el-table-column label="操作">
                    <template #default="scope">
                        <el-button type="text" size="small" @click="handleEditDish(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" class="text-danger"
                            @click="delSupplyMaterial(scope.row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>

        <!-- 7. 编辑物料弹窗 -->
        <el-dialog title="编辑物料" :visible.sync="editDishVisible" width="800px" :close-on-click-modal="false"
            append-to-body :z-index="4000">
            <el-form :model="editDishForm" :rules="editDishRules" ref="editDishFormRef" label-width="120px"
                class="form-container">
                <el-form-item prop="id" hidden>
                    <el-input v-model="editDishForm.id"></el-input>
                </el-form-item>
                <el-form-item prop="supplierId" hidden>
                    <el-input v-model="editDishForm.supplierId"></el-input>
                </el-form-item>

                <el-form-item label="物料图片">
                    <el-upload action="#" :show-file-list="false"
                        :on-change="(file) => handleEditDishImagePreview(file)" :before-upload="beforeImageUpload"
                        class="dish-avatar-uploader" :auto-upload="false">
                        <img v-if="editDishForm.imageUrl" :src="editDishForm.imageUrl" class="dish-image-preview"
                            alt="物料图片">
                        <i v-else class="el-icon-plus dish-upload-icon"></i>
                    </el-upload>
                    <div class="upload-tip">支持JPG、PNG格式，大小不超过2MB（不重新选择则保持原图片）</div>
                </el-form-item>

                <el-form-item label="物料名称" prop="bomName">
                    <el-input v-model="editDishForm.bomName" placeholder="请输入物料名称"></el-input>
                </el-form-item>

                <el-form-item label="单位" prop="unit">
                    <el-input v-model="editDishForm.unit" placeholder="请输入单位（如：kg、份）"></el-input>
                </el-form-item>

                <el-form-item label="单价(元)" prop="price">
                    <el-input v-model.number="editDishForm.price" placeholder="0.00" type="number"
                        step="0.01"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="editDishVisible = false">取消</el-button>
                <el-button type="primary" @click="submitEditDishForm">保存修改</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getSupplierList,
    add,
    delSupplier,
    edit,
    uploadSupplierQualification,
    uploadPhoto,
    getSupplyMaterials,
    addSupplyMaterial,
    delSupplyMaterial,
    editSupplyMaterial  // 新增：编辑物料接口
} from "@/api/supplier";

export default {
    data() {
        return {
            previewPhotoVisible: false,
            previewPhotoUrl: "",
            Listdish: [],
            // 图片本地存储
            dishLocalFiles: [],
            localFiles: { file1: null, file2: null },
            // 搜索表单
            searchForm: { supplierName: "", status: "" },
            statusTypeMap: { 0: "success", 1: "danger" },
            // 列表与分页
            pagedSuppliers: [],
            filteredSuppliers: [],
            currentPage: 1,
            pageSize: 10,
            // 统计数据
            totalCount: 0,
            activeCount: 0,
            totalDishCount: 0,
            monthlyNewCount: 0,
            // 弹窗状态
            formVisible: false,
            previewImageVisible: false,
            isEditMode: false,
            addDishVisible: false,
            addQualificationVisible: false,
            viewQualificationVisible: false,
            detailDrawerVisible: false,
            editDishVisible: false,  // 编辑物料弹窗状态
            // 操作标识
            currentSupplierId: "",
            replacingFileType: "",
            // 图片预览
            previewImageUrl: "",
            previewImageTitle: "",
            // 表单数据
            supplierForm: {
                supplierName: "",
                contactInfo: "",
                address: "",
                status: "",
                dishes: []
            },
            qualificationForm: {
                supplierId: "",
                file1: "",
                file2: ""
            },
            viewQualificationData: {
                supplierId: "",
                file1: "",
                file2: "",
                file1Origin: "",
                file2Origin: ""
            },
            // 编辑物料表单数据
            editDishForm: {
                id: "",
                supplierId: "",
                bomName: "",
                unit: "",
                price: null,
                imageUrl: "",
                oldImageUrl: ""
            },
            editDishLocalFile: null,  // 编辑时选择的新图片
            // 表单规则
            basicRules: {
                supplierName: [{ required: true, message: "请输入供应商名称", trigger: "blur" }],
                contactInfo: [
                    { required: true, message: "请输入联系电话", trigger: "blur" },
                    { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
                ],
                address: [{ required: true, message: "请输入联系地址", trigger: "blur" }],
                status: [{ required: true, message: "请选择合作状态", trigger: "change" }]
            },
            qualificationRules: {
                file1: [{ required: true, message: "请上传营业执照", trigger: "change" }],
                file2: [{ required: true, message: "请上传食品经营许可证", trigger: "change" }]
            },
            editDishRules: {  // 编辑物料校验规则
                bomName: [{ required: true, message: "请输入物料名称", trigger: "blur" }],
                unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
                price: [
                    { required: true, message: "请输入单价", trigger: "blur" },
                    { type: "number", min: 0, message: "单价不能为负数", trigger: "blur" }
                ]
            }
        };
    },

    mounted() {
        this.getList();
    },

    methods: {
        // ---------------------- 基础列表功能 ----------------------
        getList() {
            getSupplierList({ userId: localStorage.getItem("userId") })
                .then((response) => {
                    this.pagedSuppliers = response.data || [];
                    this.filteredSuppliers = [...this.pagedSuppliers];
                    this.calculateStats();
                })
                .catch((error) => {
                    console.error("获取供应商列表失败:", error);
                    this.$message.error("获取数据失败，请重试");
                });
        },

        calculateStats() {
            this.totalCount = this.filteredSuppliers.length;
            this.activeCount = this.filteredSuppliers.filter((s) => s.status === "0").length;
            this.totalDishCount = this.filteredSuppliers.reduce(
                (sum, s) => sum + (s.dishes?.length || 0),
                0
            );
            const today = new Date();
            const currentMonth = today.getMonth();
            const currentYear = today.getFullYear();
            this.monthlyNewCount = this.filteredSuppliers.filter((s) => {
                if (!s.createTime) return false;
                const createDate = new Date(s.createTime);
                return createDate.getMonth() === currentMonth && createDate.getFullYear() === currentYear;
            }).length;
        },

        searchSuppliers() {
            this.currentPage = 1;
            this.filteredSuppliers = this.pagedSuppliers.filter((s) => {
                const nameMatch = s.supplierName.includes(this.searchForm.supplierName);
                const statusMatch = !this.searchForm.status || s.status === this.searchForm.status;
                return nameMatch && statusMatch;
            });
        },

        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
        },
        handleCurrentChange(page) {
            this.currentPage = page;
        },
        handleRowClick(row) {
            this.$refs.supplierTable?.toggleRowSelection(row);
        },

        // ---------------------- 供应商表单（新增/编辑） ----------------------
        showAddDialog() {
            this.isEditMode = false;
            this.formVisible = true;
            this.supplierForm = {
                userId: localStorage.getItem("userId"),
                supplierName: "",
                contactInfo: "",
                address: "",
                status: "0"
            };
        },

        showEditDialog(supplier) {
            console.log(supplier);

            this.isEditMode = true;
            this.formVisible = true;
            this.supplierForm = {
                ...supplier,  // 复制原有属性
                userId: localStorage.getItem("userId")  // 赋值userId，覆盖或新增该属性
            };
        },

        saveSupplier() {
            this.$refs.basicForm.validate((valid) => {
                if (valid) {
                    const apiMethod = this.isEditMode ? edit : add;
                    apiMethod(this.supplierForm)
                        .then((response) => {
                            if (response.code === 200) {
                                this.$message.success(this.isEditMode ? "更新成功" : "新增成功");
                                this.formVisible = false;
                                this.getList();
                            } else {
                                this.$message.error(`操作失败：${response.message}`);
                            }
                        })
                        .catch(() => {
                            this.$message.error("网络错误，请重试");
                        });
                }
            });
        },

        delSupplier(supplierId) {
            this.$confirm("确定删除该供应商吗？删除后相关数据将不可恢复", "确认删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    delSupplier({ supplierId: supplierId })
                        .then((response) => {
                            if (response.code === 200) {
                                this.$message.success("删除成功");
                                this.getList();
                            } else {
                                this.$message.error(`${response.message}`);
                            }
                        })
                        .catch((error) => {
                            console.error("删除失败:", error);
                            this.$message.error("删除失败，请重试");
                        });
                })
                .catch(() => {
                    this.$message.info("已取消删除");
                });
        },

        // ---------------------- 物料管理 ----------------------
        handleShowAddDish(supplierId) {
            this.currentSupplierId = supplierId;
            this.supplierForm.dishes = [];
            this.addDishItem();
            this.addDishVisible = true;
        },

        handleShowAddDish1(supplierId) {
            getSupplyMaterials({ userId: localStorage.getItem('userId'), supplierId: supplierId })
                .then(response => {
                    this.Listdish = response.data || [];
                    this.detailDrawerVisible = true;
                })
                .catch(error => {
                    console.error("获取物料列表失败:", error);
                    this.$message.error("获取物料失败，请重试");
                });
        },

        addDishItem() {
            this.supplierForm.dishes.push({
                bomName: "",
                unit: "",
                price: null,
                imageUrl: ""
            });
            this.dishLocalFiles.push(null);
        },

        removeDishItem(index) {
            if (this.supplierForm.dishes[index].imageUrl) {
                URL.revokeObjectURL(this.supplierForm.dishes[index].imageUrl);
            }
            this.supplierForm.dishes.splice(index, 1);
            this.dishLocalFiles.splice(index, 1);
        },

        delSupplyMaterial(id) {
            this.$confirm("确定删除该商品吗？删除后相关数据将不可恢复", "确认删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    delSupplyMaterial({ id: id })
                        .then((response) => {
                            if (response.code === 200) {
                                this.$message.success("删除成功");
                                // 刷新当前供应商的物料列表
                                this.handleShowAddDish1(this.editDishForm.supplierId);
                            } else {
                                this.$message.error(`${response.message}`);
                            }
                        })
                        .catch((error) => {
                            console.error("删除失败:", error);
                            this.$message.error("删除失败，请重试");
                        });
                })
                .catch(() => {
                    this.$message.info("已取消删除");
                });
        },

        handleDishImagePreview(file, rowIndex) {
            const isJPG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";
            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("只能上传JPG/PNG格式图片");
                return;
            }
            if (!isLt2M) {
                this.$message.error("图片大小不能超过2MB");
                return;
            }

            this.$set(this.supplierForm.dishes[rowIndex], "imageUrl", URL.createObjectURL(file.raw));
            this.$set(this.dishLocalFiles, rowIndex, file.raw);
        },

        submitDishForm() {
            const valid = this.supplierForm.dishes.every((dish) => {
                return dish.bomName && dish.unit && dish.price !== undefined;
            });
            if (!valid) {
                this.$message.error("请完善所有物料信息（名称、单位、单价）");
                return;
            }

            const uploadPromises = this.supplierForm.dishes.map(async (dish, index) => {
                const formData = new FormData();
                formData.append("supplierId", this.currentSupplierId);
                formData.append("bomName", dish.bomName);
                formData.append("unit", dish.unit);
                formData.append("price", Number(dish.price));
                formData.append("userId", localStorage.getItem('userId'));

                if (this.dishLocalFiles[index]) {
                    formData.append("file", this.dishLocalFiles[index]);
                }

                const uploadRes = await addSupplyMaterial(formData);
                if (uploadRes.code !== 200) {
                    throw new Error(`物料「${dish.bomName}」上传失败：${uploadRes.message || '未知错误'}`);
                }
                return uploadRes.data;
            });

            Promise.all(uploadPromises)
                .then(() => {
                    this.$message.success("所有物料上传成功！");
                    this.addDishVisible = false;
                    this.getList();
                    this.supplierForm.dishes = [];
                    this.dishLocalFiles = [];
                })
                .catch((error) => {
                    console.error("上传失败：", error);
                    this.$message.error(error.message || "物料上传失败，请重试");
                });
        },

        // ---------------------- 物料编辑功能 ----------------------
        handleEditDish(row) {
            // 填充当前物料数据到编辑表单
            this.editDishForm = {
                id: row.id,
                supplierId: row.supplierId,  // 确保物料数据包含supplierId
                bomName: row.bomName,
                unit: row.unit,
                price: Number(row.price),
                imageUrl: row.photo || "",
                oldImageUrl: row.photo || ""  // 保存原始图片用于回滚
            };
            this.editDishLocalFile = null;  // 重置新图片
            if (this.$refs.editDishFormRef) {
                this.$refs.editDishFormRef.clearValidate();
            }
            this.editDishVisible = true;
        },

        handleEditDishImagePreview(file) {
            const isJPG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";
            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("只能上传JPG/PNG格式图片");
                return;
            }
            if (!isLt2M) {
                this.$message.error("图片大小不能超过2MB");
                return;
            }
            this.editDishForm.imageUrl = URL.createObjectURL(file.raw);
            this.editDishLocalFile = file.raw;
        },
        submitEditDishForm() {
            this.$refs.editDishFormRef.validate(async (valid) => {
                if (valid) {
                    try {
                        // 1. 确认编辑物料的接口函数存在（核心修复：绑定接口函数）
                        const apiMethod = editSupplyMaterial; // 直接关联导入的接口函数
                        if (typeof apiMethod !== 'function') {
                            throw new Error("编辑物料接口未定义，请检查接口导入");
                        }

                        // 2. 构建FormData（保持原逻辑不变）
                        const formData = new FormData();
                        formData.append("id", this.editDishForm.id); // 必传：物料ID（用于定位更新项）
                        // formData.append("supplierId", this.editDishForm.supplierId); // 补充：确保关联供应商
                        formData.append("bomName", this.editDishForm.bomName);
                        formData.append("unit", this.editDishForm.unit);
                        formData.append("price", this.editDishForm.price);
                        formData.append("userId", localStorage.getItem("userId"));

                        // 3. 如有新图片，附加文件（保持原逻辑不变）
                        if (this.editDishLocalFile) {
                            formData.append("file", this.editDishLocalFile);
                        }

                        // 4. 调用编辑接口（使用绑定好的apiMethod）
                        const response = await apiMethod(formData);
                        if (response.code === 200) {
                            this.$message.success("物料修改成功！");
                            this.editDishVisible = false;
                            // 刷新当前供应商的物料列表
                            // this.handleShowAddDish1(this.editDishForm.supplierId);、
                            this.getList()
                            // 释放临时预览URL，避免内存泄漏
                            if (this.editDishForm.imageUrl !== this.editDishForm.oldImageUrl) {
                                URL.revokeObjectURL(this.editDishForm.imageUrl);
                            }
                        } else {
                            this.$message.error(`修改失败：${response.message || "未知错误"}`);
                        }
                    } catch (error) {
                        console.error("编辑物料异常：", error);
                        this.$message.error(error.message || "网络错误，请重试");
                        // 回滚图片预览（保持原逻辑不变）
                        if (this.editDishForm.imageUrl !== this.editDishForm.oldImageUrl) {
                            this.editDishForm.imageUrl = this.editDishForm.oldImageUrl;
                            URL.revokeObjectURL(this.editDishForm.imageUrl);
                        }
                    }
                }
            });
        },

        // ---------------------- 资质图片（新增） ----------------------
        handleShowQualificationDialog(supplierId) {
            this.currentSupplierId = supplierId;
            this.qualificationForm = { supplierId, file1: "", file2: "" };
            this.localFiles = { file1: null, file2: null };
            this.addQualificationVisible = true;
        },

        Close() {
            this.viewQualificationVisible = false;
            this.getList();
        },

        handleQualificationPreview(file, fileType) {
            const isJPG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";
            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("只能上传JPG/PNG格式图片");
                return;
            }
            if (!isLt2M) {
                this.$message.error("图片大小不能超过2MB");
                return;
            }

            this.qualificationForm[fileType] = URL.createObjectURL(file.raw);
            this.localFiles[fileType] = file.raw;
        },

        submitQualificationForm() {
            this.$refs.qualificationFormRef.validate((valid) => {
                if (valid) {
                    if (!this.localFiles.file1 || !this.localFiles.file2) {
                        this.$message.error("请先选择营业执照和食品经营许可证");
                        return;
                    }

                    const formData = new FormData();
                    formData.append("file1", this.localFiles.file1);
                    formData.append("file2", this.localFiles.file2);
                    formData.append("supplierId", this.qualificationForm.supplierId);

                    uploadPhoto(formData)
                        .then((response) => {
                            if (response.code === 200) {
                                this.qualificationForm.file1 = response.data.file1Url;
                                this.qualificationForm.file2 = response.data.file2Url;

                                uploadSupplierQualification(this.qualificationForm)
                                    .then((res) => {
                                        if (res.code === 200) {
                                            this.$message.success("资质上传成功！");
                                            this.addQualificationVisible = false;
                                            this.getList();
                                            this.localFiles = { file1: null, file2: null };
                                            this.qualificationForm = { supplierId: "", file1: "", file2: "" };
                                        } else {
                                            this.$message.error(`资质关联失败：${res.message}`);
                                        }
                                    })
                                    .catch(() => {
                                        this.$message.error("资质关联失败，请重试");
                                    });
                            } else {
                                this.$message.error(`文件上传失败：${response.message}`);
                            }
                        })
                        .catch((error) => {
                            console.error("文件上传异常：", error);
                            this.getList();
                            this.addQualificationVisible = false;
                        });
                }
            });
        },

        // ---------------------- 资质图片（查看+更换） ----------------------
        handleShowQualificationDialog1(supplierId) {
            let targetObj = null;
            for (let i = 0; i < this.pagedSuppliers.length; i++) {
                if (Number(this.pagedSuppliers[i].supplierId) === Number(supplierId)) {
                    targetObj = this.pagedSuppliers[i];
                    break;
                }
            }

            if (!targetObj) {
                this.$message.error("未找到该供应商数据");
                return;
            }

            this.viewQualificationData = {
                supplierId: supplierId,
                file1: targetObj.photo1 || "",
                file2: targetObj.photo2 || "",
                file1Origin: targetObj.photo1 || "",
                file2Origin: targetObj.photo2 || ""
            };
            this.viewQualificationVisible = true;
        },

        handleReplaceQualification(fileType) {
            this.replacingFileType = fileType;
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "image/jpeg,image/png";
            input.style.display = "none";

            input.addEventListener("change", (e) => {
                const file = e.target.files[0];
                if (file) {
                    this.uploadReplacedQualification(file);
                }
                document.body.removeChild(input);
            });

            document.body.appendChild(input);
            input.click();
        },

        async uploadReplacedQualification(file) {
            const fileType = this.replacingFileType;
            if (!fileType) return;

            try {
                const isJPG = file.type === "image/jpeg" || file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error("只能上传JPG/PNG格式图片");
                    return;
                }
                if (!isLt2M) {
                    this.$message.error("图片大小不能超过2MB");
                    return;
                }

                const tempUrl = URL.createObjectURL(file);
                this.viewQualificationData[fileType] = tempUrl;

                const formData = new FormData();
                formData.append(fileType, file);
                formData.append("supplierId", this.viewQualificationData.supplierId);

                const response = await uploadPhoto(formData);
                if (response.code === 200 && response.data[`${fileType}Url`]) {
                    const officialUrl = response.data[`${fileType}Url`];
                    this.viewQualificationData[fileType] = officialUrl;
                    this.$message.success(`${fileType === "file1" ? "营业执照" : "食品经营许可证"}更换成功`);

                    for (let i = 0; i < this.pagedSuppliers.length; i++) {
                        if (Number(this.pagedSuppliers[i].supplierId) === Number(this.viewQualificationData.supplierId)) {
                            this.pagedSuppliers[i][fileType === "file1" ? "photo1" : "photo2"] = officialUrl;
                            break;
                        }
                    }
                    this.filteredSuppliers = [...this.pagedSuppliers];
                } else {
                    this.$message.error(`${response.message}`);
                }

                URL.revokeObjectURL(tempUrl);
            } catch (error) {
                this.viewQualificationData[fileType] = this.viewQualificationData[`${fileType}Origin`];
                this.$message.error("图片更换异常，请重试");
                console.error("资质图片更换失败：", error);
            }
        },

        // ---------------------- 通用工具 ----------------------
        beforeImageUpload(file) {
            const isJPG = file.type === "image/jpeg" || file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) this.$message.error("只能上传JPG/PNG格式图片");
            if (!isLt2M) this.$message.error("图片大小不能超过2MB");
            return isJPG && isLt2M;
        },

        formatStatus(status) {
            return status === "0" ? "合作中" : "已终止";
        },

        previewImage(url, title) {
            this.previewImageUrl = url;
            this.previewImageTitle = title;
            this.previewImageVisible = true;
        },

        previewDishPhoto(url) {
            this.previewPhotoUrl = url;
            this.previewPhotoVisible = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.supplier-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 搜索区 */
.search-card {
    margin-bottom: 20px;

    .search-form {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        padding: 10px 0;
    }
}

/* 统计卡片 */
.stats-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
}

.stat-card {
    flex: 1;
    min-width: 200px;

    .stat-item {
        position: relative;
        padding: 15px;

        .stat-label {
            font-size: 14px;
            color: #6b7280;
            margin-bottom: 8px;
            display: block;
        }

        .stat-value {
            font-size: 28px;
            font-weight: bold;
            color: #165dff;
        }

        .stat-icon {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            color: rgba(22, 93, 255, 0.1);
        }
    }
}

/* 列表区 */
.main-content {
    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }
}

/* 通用样式 */
.text-danger {
    color: #ff4d4f;
}

.step-content {
    padding: 10px 0;
}

.form-container {
    padding: 10px 0;
}

/* 物料表格 */
.dish-table {
    margin-bottom: 10px;
}

.dish-avatar-uploader {
    display: inline-block;

    .dish-image-preview {
        width: 60px;
        height: 60px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #eee;
    }

    .dish-upload-icon {
        font-size: 24px;
        color: #8c939d;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        background-color: #f6f6f6;
    }
}

/* 新增资质图片 */
.avatar-uploader {
    display: inline-block;
    margin-top: 5px;

    .license-image {
        width: 300px;
        height: 180px;
        object-fit: contain;
        border: 1px solid #eee;
        border-radius: 4px;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        background-color: #f6f6f6;
    }
}

.upload-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #6b7280;
}

/* 查看资质图片弹窗 */
.view-qualification-container {
    padding: 10px 0;

    .qualification-item {
        margin-bottom: 30px;

        .item-title {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            &::before {
                content: "";
                width: 4px;
                height: 16px;
                background-color: #165dff;
                margin-right: 8px;
                border-radius: 2px;
            }
        }

        .image-container {
            position: relative;
            display: inline-block;
            border: 1px solid #eee;
            border-radius: 4px;
            cursor: pointer;
            transition: border-color 0.3s ease;

            &:hover {
                border-color: #165dff;
            }

            .qualification-image {
                width: 700px;
                height: auto;
                max-height: 400px;
                object-fit: contain;
                padding: 15px;
            }

            .image-placeholder {
                width: 700px;
                height: 200px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #999;
                background-color: #fafafa;

                .el-icon-picture-outline {
                    font-size: 40px;
                    margin-bottom: 10px;
                }
            }

            .replace-tip {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 8px 0;
                background-color: rgba(0, 0, 0, 0.6);
                color: #fff;
                font-size: 12px;
                text-align: center;
                opacity: 0;
                transition: opacity 0.3s ease;
            }

            &:hover .replace-tip {
                opacity: 1;
            }
        }

        &.no-image .image-container {
            cursor: default;

            &:hover {
                border-color: #eee;
            }
        }
    }
}

/* 图片预览弹窗 */
.image-preview-container {
    text-align: center;
    padding: 20px 0;

    .preview-image {
        max-width: 100%;
        max-height: 600px;
        object-fit: contain;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
    }
}

/* 弹窗底部按钮 */
.dialog-footer {
    text-align: right;
}

.dish-photo-container {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: hidden;

    .dish-photo {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
            transform: scale(1.05);
        }
    }

    .dish-photo-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f5f5;
        color: #ccc;

        .el-icon-picture-outline {
            font-size: 24px;
        }
    }
}

/* 抽屉样式 */
.detail-drawer {
    padding: 20px;
}
</style>